import React, { useEffect, useState } from 'react';
import './MapTile.css';
import { MapHex } from '../lib/interfaces';
import useLocal from '../lib/useLocal';
import { hexDetailIdAtom } from '../lib/atoms';
import { useRecoilState } from 'recoil';
const FLIPTIME = 500;

interface MapTileProps {
    hexData: MapHex;
    blank: boolean;
}

export default function MapTile({ hexData, blank }: MapTileProps) {
    const [nextOpen, setNextOpen] = useLocal('nextOpen') as [number, Function];
    const [flipped, setFlipped] = useState(false);
    const [hexDetailId, setHexDetailId] = useRecoilState(hexDetailIdAtom);

    useEffect(() => {
        if (hexData.order < nextOpen) {
            setTimeout(() => setFlipped(true), FLIPTIME * hexData.order);
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    function flipIt() {
        setFlipped(true);
        setNextOpen(nextOpen + 1);
    }

    function handleClick(e:any) {
        e.stopPropagation();
        
        if (hexData.order === nextOpen) {
            flipIt();
        }
        else if (flipped) {
            // setHexDetailId(hexData.id === hexDetailId ? 0 : hexData.id);
            setHexDetailId(hexData.id);
        }
    }

    return <div className={`hex-${hexData.id}`} onClick={blank ? undefined : handleClick}>
        {blank ? <div className='blank' /> : <>
            <div className={`back ${flipped ? '' : 'active'}`} >
                {blank || hexData.order}
            </div>
            <div className={`tile 
                ${flipped ? 'active' : ''}
                ${hexData.id === hexDetailId ? 'selected' : ''}
            `} />
        </>}
    </div>;
};